<template>
  <div class="linkbar-wrapper">
    <el-menu mode="horizontal" theme="dark" 
    :default-active="activeId"
     background-color="#304156"
    text-color="#fff"
    active-text-color="#1890ff"
    >
        <img src="/static/images/logo.png"/>
        <span class="admin-title"></span>
        <!-- <el-menu-item v-for="item in links" :key="item.id" :index="item.id"><a :href="item.url">{{item.desc}}</a></el-menu-item> -->
        <div style="float: right; margin-right: 30px;color: #fff;font-size: 14px;line-height: 58px; cursor: pointer" @click="goto" v-show="btnCode.btn100001">待审核消息{{num}}</div>
    </el-menu>
  </div>
</template>

<script>
    function getUrlInfo() {
        const domainParts = /([a-zA-Z0-9\-]+)((\.[a-zA-Z0-9\-]+)*)/.exec(window.location.hostname)
        return {
            id: domainParts[1],
            upperDomain: domainParts[2],
            origin: window.location.origin
        }
    }

    function isLocal() {
        const hostname = window.location.hostname
        return hostname.indexOf('localhost') !== -1 || hostname.indexOf('192.168') !== -1
    }

    function isTest() {
        const hostname = window.location.hostname
        return hostname.indexOf('.cn') !== -1
    }
    function getLinks() {
        const urlPlaceholder = '/'
        const linkData = {
            links: [{
                // src:'./src/assets/logo/logo1.png',
                desc: '智租BOSS',
                id: 'claim-admin'
            }],
            num: 1,
        }

        const urlInfo = getUrlInfo()
        const activeId = getActiveId(linkData.links)
        const num = null
        const links = linkData.links.map(({desc, id, href}) => ({
            desc,
            id,
            url: id === 'kf' ? href : id === activeId ? 'javascript:;' :
                isLocal() ? 'javascript:;' : 'javascript:;'
        }))
        return {links, activeId, num}
    }

    function getActiveId(links) {
        const pageTitle = window.document.title || ''
        const urlInfo = getUrlInfo()
        const hit = links.find(
                ({id}) => id === urlInfo.id
            )
            || links.find(
                ({desc}) => pageTitle.indexOf(desc) !== -1
            )
        return hit && hit.id || ''
    }
    import MixinWx from '@/mixin/user'
    import Api from '@/services'
    export default {
        name: 'Linkbar',
        mixins: [ MixinWx ],
        data() {
            return getLinks()
        },
        created() {
        },
        methods: {
            goto() {
                this.$router.push({path: '/car/8'});
            }
        }
    }
</script>

<style rel="stylesheet/css" scoped>
  .linkbar-wrapper {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 100;
  }
  .el-menu-item.is-active {
    color: #bfcbd9;
   float: left;
   /* margin-left: 15px; */
    /* text-align: center; */
    /*border-bottom: 5px solid #20a0ff;*/
  }
  /* .el-menu-item:hover {
    color: #20a0ff;
  } */
  .el-menu-item > a {
    text-decoration: none;
   margin-left: -15px;
   font-size: 24px;
   /* font-family: '华文行楷'; */
  }
 .el-menu >img {
   /* margin: 18px auto; */
   /* width: 50px; */
   height: 36px;
    float: left;
    margin: 10px 10px;
   margin-left: 20px;
}
.admin-title{
    line-height: 60px;
    font-size: 18px;
    color: #ffffff;
    margin-left: 30px;
}
</style>



// WEBPACK FOOTER //
// Linkbar.vue?8bfabf4c